import { render, staticRenderFns } from "./TariffMandatoryItemListPage.vue?vue&type=template&id=33b912a2&"
import script from "./TariffMandatoryItemListPage.vue?vue&type=script&lang=ts&"
export * from "./TariffMandatoryItemListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports